import React, { useState, useEffect } from "react";
import InView from 'react-intersection-observer';
import { industryRetailAIObj } from "../industries-retail/healthcare-industry-constants";

export default function IndustryRetailTabs(props) {
  const _isMounted = false;
  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });

  const [itemIsActive, setItemIsActive] = useState(1);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = () => setTimeout(() => {
      const active = itemIsActive >= 4 ? 1 : itemIsActive + 1;
      setItemIsActive(active);
    }, 7000);
    let timerId = null;
    timerId = timer();

    return () => {
      clearTimeout(timerId);
    };
  }, [itemIsActive]);

  const { title, content, tabItems, serviceMediaOne, serviceMediaTwo, serviceMediaThree, serviceMediaFour, serviceMediaFive } = industryRetailAIObj;
  return (
    <InView as="div" id={props.id} onChange={(inView) => setIsVisible(inView)} className="service-retail-tab-section section-gap"
      threshold={[0.05]}>
      <div className="container">
        <div className="section-gap-small retail-ai-title">
            <h2 className="h2">{title}</h2>
            <p>{content}</p>
        </div>
        <div className="row d-flex flex-wrap">
        {!isMobile && <>
          <div className="col service-retail-tab-link-block">
            <ul className="service-retail-tab-list">
              {tabItems.map((item, i) =>
                <li key={i} onClick={() => { setItemIsActive(i + 1); }} className={"service-retail-tab-item d-flex" + (itemIsActive === (i + 1) ? " active" : "")}>
                  <div className="service-tab-animation">
                    <div className="pie spinner"></div>
                    <div className="pie filler"></div>
                    <div className="mask"></div>
                    <span className="item-count">0{(i + 1)}</span>
                  </div>
                  <div className="service-retail-tab-detail">
                    <h2 className="h4">{item.header}</h2>
                  </div>
                </li>)}
            </ul>

          </div>
          </>}
          
          <div className="col service-retail-tab-media-block">
            <div className="service-retail-tab-media-inner">
              {isMobile && <>  
                <div onClick={() => { setItemIsActive( 0 + 1); }} className={"service-retail-tab-item d-flex" + (itemIsActive === ( 0 + 1) ? " active" : "")}>
                      <div className="service-tab-animation">
                      <div className="pie spinner"></div>
                      <div className="pie filler"></div>
                      <div className="mask"></div>
                      <span className="item-count">0{(0 + 1)}</span>
                      </div>
                      <div className="service-retail-tab-detail">
                        <h2 className="h4">{tabItems[0].header}</h2>
                      </div>
                </div>
              </>}

              <div className={"service-retail-item item-one" + (itemIsActive === 1 ? " active" : "")}>
                {serviceMediaOne.map((item, i) => <div key={i}><img src={item.source} title={item.imagetitle} alt={item.imagealt} /><p>{ item.content }</p></div>)}
              </div>

              {isMobile && <>  
              <div onClick={() => { setItemIsActive( 0 + 2); }} className={"service-retail-tab-item d-flex" + (itemIsActive === ( 0 + 2) ? " active" : "")}>
                  <div className="service-tab-animation">
                  <div className="pie spinner"></div>
                  <div className="pie filler"></div>
                  <div className="mask"></div>
                  <span className="item-count">0{(0 + 2)}</span>
                  </div>
                  <div className="service-retail-tab-detail">
                    <h2 className="h4">{tabItems[1].header}</h2>
                  </div>
              </div>
              </>}

              <div className={"service-retail-item item-two" + (itemIsActive === 2 ? " active" : "")}>
                {serviceMediaTwo.map((item, i) => <div key={i}><img src={item.source} title={item.imagetitle} alt={item.imagealt} /><p>{ item.content }</p></div>)}
              </div>

              {isMobile && <>  
              <div onClick={() => { setItemIsActive( 0 + 3); }} className={"service-retail-tab-item d-flex" + (itemIsActive === ( 0 + 3) ? " active" : "")}>
                  <div className="service-tab-animation">
                  <div className="pie spinner"></div>
                  <div className="pie filler"></div>
                  <div className="mask"></div>
                  <span className="item-count">0{(0 + 3)}</span>
                  </div>
                  <div className="service-retail-tab-detail">
                    <h2 className="h4">{tabItems[2].header}</h2>
                  </div>
              </div>
              </>}

              <div className={"service-retail-item item-three" + (itemIsActive === 3 ? " active" : "")}>
                {serviceMediaThree.map((item, i) => <div key={i}><img src={item.source} title={item.imagetitle} alt={item.imagealt} /><p>{ item.content }</p></div>)}
              </div>

              {isMobile && <>  
              <div onClick={() => { setItemIsActive( 0 + 4); }} className={"service-retail-tab-item d-flex" + (itemIsActive === ( 0 + 4) ? " active" : "")}>
                  <div className="service-tab-animation">
                  <div className="pie spinner"></div>
                  <div className="pie filler"></div>
                  <div className="mask"></div>
                  <span className="item-count">0{(0 + 4)}</span>
                  </div>
                  <div className="service-retail-tab-detail">
                    <h2 className="h4">{tabItems[3].header}</h2>
                  </div>
              </div>
              </>}

              <div className={"service-retail-item item-four" + (itemIsActive === 4 ? " active" : "")}>
                {serviceMediaFour.map((item, i) => <div key={i}><img src={item.source} title={item.imagetitle} alt={item.imagealt} /><p>{ item.content }</p></div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </InView >
  );
};

